import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { MachineryManagement } from './types';

export const MachineryManagementSchema = object<MachineryManagement>({
  name: string().required(() => i18n.t('validation:required')),
  type: string().required(() => i18n.t('validation:required')),
  typeOfMeasurement: string().required(() => i18n.t('validation:required')),
});
